<template>
  <v-card>
    <v-form @submit.prevent="submitBillsForm()" ref="billingsForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon
                :color="$store.state.global.pages.billing.color"
              >{{$store.state.global.pages.billing.icon}}</v-icon>
            </span>
            <span class="headline">
              Create Bills
              <span class="grey--text subheading">
                -
                <span class="font-weight-bold">{{projectName}}</span> Dockets for the billing period of
                <span class="font-weight-bold">{{billingPeriod}}</span>
              </span>
            </span>
          </v-flex>
          <card-divider-header></card-divider-header>

          <v-flex class="text-xs-center" xs12 v-if="working">
            <v-progress-circular indeterminate :color="$store.state.global.pages.billing.color"></v-progress-circular>
            <div class="text-xs-center body-1 grey--text text--lighten-1 mt-3">Loading your data...</div>
          </v-flex>

          <flex-sub-header>
            Control Total
            <div class="font-italic caption grey--text">Bill will only be created if bill and control total match</div>
          </flex-sub-header>
          <v-flex xs12>
            <v-text-field label="Control Total" prepend-icon="money" type="number" v-model.number="controlTotal" :rules="totalRules"></v-text-field>
          </v-flex>
          <flex-sub-header>
            Bill Date
          </flex-sub-header>
          <v-flex xs12>
            <date-picker-wrapper
              v-model="date"
              :rules="dateRules"
              label="Bill Date"
              color="indigo"
            ></date-picker-wrapper>
          </v-flex>
          <flex-sub-header>
            Reference #
            <div class="font-italic caption grey--text">Notes: Reference numbers will be popluated across all bills created by this process.</div>
          </flex-sub-header>
          <v-flex xs6>
            <v-text-field label="Reference (RCTI)" prepend-icon="insert_drive_file" type="text" v-model="externalRef" :rules="externalRefRules"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field label="Xero Reference" prepend-icon="insert_drive_file" type="text" v-model="xeroRef" :rules="xeroRefRules"></v-text-field>
          </v-flex>

          <flex-sub-header>
            Notes
            <div
              class="font-italic caption grey--text"
            >These notes will apply for all bills about to be created</div>
          </flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field label="Internal Notes" prepend-icon="note" v-model="internalNotes"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Invoice Notes" prepend-icon="note" v-model="invoiceNotes"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
        <v-btn
          flat
          type="submit"
          color="green darken-1"
          :loading="loading"
        >Create</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
import BillValidation from '@/services/validation/billValidation'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
export default {
  components: {
    DatePickerWrapper
  },
  mixins: [BillValidation],
  props: {
    dialogOpen: Boolean
  },
  data() {
    return {
      loading: false,
      working: false,
      controlTotal: null,
      date: new Date().toISOString().substr(0, 10),
      internalNotes: '',
      invoiceNotes: '',
      externalRef: '',
      xeroRef: '',
      previewData: null
    }
  },
  computed: {
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    projectName() {
      if (!!this.projectId) {
        return this.$store.state.projects.projects.filter(project => {
          return project.id == this.projectId
        })[0].name
      } else {
        return ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submitBillsForm() {
      if (!this.$refs.billingsForm.validate()) {
        this.snack({ color: 'yellow', text: 'Please correct form errors!' })
        return
      }
      this.addBills()
    },
    async addBills() {
      this.loading = true
      const payload = {
        projectId: this.projectId,
        billingPeriod: this.billingPeriod,
        controlTotal: this.controlTotal,
        externalRef: this.externalRef,
        xeroRef: this.xeroRef,
        internalNotes: this.internalNotes,
        invoiceNotes: this.invoiceNotes,
        date: this.date
      }
      try {
        const result = await ApprovedBillLineService.addBills(payload)
        this.loading = false
        this.resetForm()
        this.close()
        const billIds = result.data.result.createdBills.map(
          createdBill => createdBill.bill.id
        )
        const billIdsString = JSON.stringify(billIds)
        this.$router.push({ name: 'billing', query: { ids: billIdsString } })
      } catch (err) {
        console.log(err)
        this.snack({ text: err.response.data.message, color: 'red' })
        this.loading = false
      }
    },
    resetForm() {
      this.internalNotes = ''
      this.invoiceNotes = ''
    }
  }
}
</script>
